import { UncancelActionContext } from "./UncancelActionContext";
import useUncancel from "./useUncancel";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import usePrepareUncancel from "./usePrepareUncancel";
import { EditActionContext } from "../edit/EditActionContext";

function useUncancelAction(modelConfig: any, index: any): any {
  const prepareUncancel = usePrepareUncancel();
  const prepareUncancelFunction = (id: any) => prepareUncancel(id);

 const {element, setElement} = useContext(EditActionContext)
 
   const onSuccessUncancel = () => {
     setShowModal(false);
     index();
     if (element) {
       setElement({ ...element, cancelled: false });
     }
   };

  const cancel = useUncancel(modelConfig);

  const cancelFunction = () => cancel(onSuccessUncancel);

  const contextInstance = useContext(UncancelActionContext);
  const { setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "uncancel",
    onSubmit: () => cancelFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t(`are_you_sure_you_want_to_uncancel_this_${modelConfig.modelName}?`)}
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    prepareUncancelFunction,
    actionTemplate,
  };
}

export default useUncancelAction;
